var map = {
	"./anyone.md": 1571,
	"./careless-shame.md": 4920,
	"./choose-love.md": 4236,
	"./colder-weather.md": 7615,
	"./february-sky.md": 6981,
	"./late-have-i-loved-you.md": 7426,
	"./lovely-soul.md": 9437,
	"./thingsandinbetweens.md": 3345,
	"./this-is-not-celery.md": 2918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3472;